import Building         from "../../../domain/fundamentals/address/Building";
import City             from "../../../domain/fundamentals/address/City";
import PostalCode       from "../../../domain/fundamentals/address/PostalCode";
import Prefecture       from "../../../domain/fundamentals/address/Prefecture";
import Street           from "../../../domain/fundamentals/address/Street";
import Email            from "../../../domain/fundamentals/email/Email";
import Office           from "../../../domain/office/Office";
import OfficeName       from "../../../domain/office/OfficeName";
import OfficeNameKana   from "../../../domain/office/OfficeNameKana";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_OFFICE = "SET_OFFICE",
  SET_OFFICE_NAME = "SET_OFFICE_NAME",
  SET_OFFICE_NAME_KANA = "SET_OFFICE_NAME_KANA",
  SET_OFFICE_EMAIL = "SET_OFFICE_EMAIL",
  SET_OFFICE_ADDRESS_POSTAL_CODE = "SET_OFFICE_ADDRESS_POSTAL_CODE",
  SET_OFFICE_ADDRESS_PREFECTURE = "SET_OFFICE_ADDRESS_PREFECTURE",
  SET_OFFICE_ADDRESS_CITY = "SET_OFFICE_ADDRESS_CITY",
  SET_OFFICE_ADDRESS_STREET = "SET_OFFICE_ADDRESS_STREET",
  SET_OFFICE_ADDRESS_BUILDING = "SET_OFFICE_ADDRESS_BUILDING",
}

export interface SetOfficeAction extends ResKaReduxAction {
  office: Office;
}

export interface SetOfficeNameAction extends ResKaReduxAction {
  name: OfficeName;
}

export interface SetOfficeNameKanaAction extends ResKaReduxAction {
  nameKana: OfficeNameKana;
}

export interface SetOfficeEmailAction extends ResKaReduxAction {
  email: Email;
}

export interface SetOfficeAddressPostalCodeAction extends ResKaReduxAction {
  postalCode: PostalCode;
}

export interface SetOfficeAddressPrefectureAction extends ResKaReduxAction {
  prefecture: Prefecture;
}

export interface SetOfficeAddressCityAction extends ResKaReduxAction {
  city: City;
}

export interface SetOfficeAddressStreetAction extends ResKaReduxAction {
  street: Street;
}

export interface SetOfficeAddressBuildingAction extends ResKaReduxAction {
  building: Building;
}

export type OfficeAction =
  SetOfficeAction
  | SetOfficeNameAction
  | SetOfficeNameKanaAction
  | SetOfficeEmailAction
  | SetOfficeAddressPostalCodeAction
  | SetOfficeAddressPrefectureAction
  | SetOfficeAddressCityAction
  | SetOfficeAddressStreetAction
  | SetOfficeAddressBuildingAction
  ;

export const setOffice = (office: Office): SetOfficeAction => ({
  type: ACTION_TYPE.SET_OFFICE,
  office: office,
});

export const setOfficeName = (name: OfficeName): SetOfficeNameAction => ({
  type: ACTION_TYPE.SET_OFFICE_NAME,
  name: name,
});

export const setOfficeNameKana = (nameKana: OfficeNameKana): SetOfficeNameKanaAction => ({
  type: ACTION_TYPE.SET_OFFICE_NAME_KANA,
  nameKana: nameKana,
});

export const setOfficeEmail = (email: Email): SetOfficeEmailAction => ({
  type: ACTION_TYPE.SET_OFFICE_EMAIL,
  email: email,
});

export const setOfficeAddressPostalCode = (postalCode: PostalCode): SetOfficeAddressPostalCodeAction => ({
  type: ACTION_TYPE.SET_OFFICE_ADDRESS_POSTAL_CODE,
  postalCode: postalCode,
});

export const setOfficeAddressPrefecture = (prefecture: Prefecture): SetOfficeAddressPrefectureAction => ({
  type: ACTION_TYPE.SET_OFFICE_ADDRESS_PREFECTURE,
  prefecture: prefecture,
});

export const setOfficeAddressCity = (city: City): SetOfficeAddressCityAction => ({
  type: ACTION_TYPE.SET_OFFICE_ADDRESS_CITY,
  city: city,
});

export const setOfficeAddressStreet = (street: Street): SetOfficeAddressStreetAction => ({
  type: ACTION_TYPE.SET_OFFICE_ADDRESS_STREET,
  street: street,
});

export const setOfficeAddressBuilding = (building: Building): SetOfficeAddressBuildingAction => ({
  type: ACTION_TYPE.SET_OFFICE_ADDRESS_BUILDING,
  building: building,
});
